import React from "react";
import config from 'util/config.js'


const RenderFallback = () => (
  <div><h1 style={{textAlign:"center"}}>Error</h1></div>
);

export const ErrorBoundaryConstructor = (WrappedComponent, fallbackComponent = RenderFallback, onError = undefined) =>{ 
  return class ErrorBoundary extends React.Component {
    
    constructor(props) {
      super(props);
      this.state = {error: false};
    }
    
    unstable_handleError(e) {
      console.warn("unstable_handleError",e);
      onError && onError(e);
      this.setState({error: true});
    }
    
    render() { 
      const Comp = (config.production && this.state.error) ? fallbackComponent : WrappedComponent;
      return <Comp {...this.props}/>;
    } 
  }
  
};

export const DefaultErrorBoundary = Component => {
  return ErrorBoundaryConstructor(Component);
};

export default DefaultErrorBoundary